/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OfferActivitiesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Offer Activities',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M10 5a1 1 0 0 1 1-1h17V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3V5Z" />
    <path d="M10 5a1 1 0 0 1 1-1h17V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3V5Z" />
    <path
      d="M10 20H5a1 1 0 0 1-1-1v-9H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h17v-4h-7a1 1 0 0 1-1-1v-3ZM20.496 14.054a.494.494 0 0 0-.496.5v19.782a.494.494 0 0 0 .846.354L26.51 29h8c.446 0 .48-.726.226-.98L20.846 14.2a.492.492 0 0 0-.35-.146Z"
    />
    <path
      d="M34 21V7a1 1 0 0 0-1-1H13a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-7.446a2.502 2.502 0 0 1 2.496-2.5 2.472 2.472 0 0 1 1.764.734L31.518 22H33a1 1 0 0 0 1-1Z"
    />
  </svg>`;
};
